const doc = [({"usage":"使い方", "setting":"設定方法", "download":"ダウンロード", "install":"インストール方法"})];
module.exports = doc.length <= 1 ? doc[0] : doc;